/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Collapse, CollapseProps, Group } from '@mantine/core'

function Filters (props: CollapseProps) {
  const { children } = props

  if (!children) return null

  return (
    <Collapse {...props}>
      <Group align="start" p="sm" bg="gray.0">
        {children}
      </Group>
    </Collapse>
  )
}

export default Filters
